import Plugin from 'src/plugin-system/plugin.class';
import ViewportDetection from 'src/helper/viewport-detection.helper';
import Swiper from 'swiper/bundle';

export default class HeaderPlugin extends Plugin {

    static options = {
        viewPorts: [
            'XXXS',
            'XXS',
            'XS',
            'SM',
            'MD',
            'LG',
            'XL'
        ]
    };

    init() {

        this._registerEvents();

        this.gaerenSwiper = new Swiper('.mobile-sub-navbars .sub-navbar-menu-gaeren', {
            slidesPerView: "auto",
            spaceBetween: 10,
            loop: false,
            centeredSlides: false,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
                draggable: true,
                snapOnRelease: true
            }
        });

        this.lagernSwiper = new Swiper('.mobile-sub-navbars .sub-navbar-menu-lagern', {
            slidesPerView: "auto",
            spaceBetween: 10,
            loop: false,
            centeredSlides: false,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
                draggable: true,
                snapOnRelease: true
            }
        });

        this.schockenSwiper = new Swiper('.mobile-sub-navbars .sub-navbar-menu-schocken', {
            slidesPerView: "auto",
            spaceBetween: 10,
            loop: false,
            centeredSlides: false,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
                draggable: true,
                snapOnRelease: true
            }
        });

        this.unternehmenSwiper = new Swiper('.mobile-sub-navbars .sub-navbar-unternehmen', {
            slidesPerView: "auto",
            spaceBetween: 10,
            loop: false,
            centeredSlides: false,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
                draggable: true,
                snapOnRelease: true
            }
        });

        // document.addEventListener('Viewport/hasChanged', () => {
        //     this.unternehmenSwiper.forEach((swiper) => {
        //         swiper.update();
        //     });

        //     this.productsSwiper.forEach((swiper) => {
        //         swiper.update();
        //     });
        // });

        var desktopSubNavs = document.querySelectorAll(".desktop-sub-navbars .sub-navbar");
        var mobileSubNavs = document.querySelectorAll(".mobile-sub-navbars .sub-navbar");
        var subNavDesktopLinks = document.querySelectorAll(".navbar-nav-desktop .has--sub-nav");
        var subNavMobileLinks = document.querySelectorAll(".mobile-nav .has--sub-nav");

        document.querySelector(".navbar-always-toggler").addEventListener("click", function() {

            desktopSubNavs.forEach((item, thisI) => {
                item.classList.remove("is--open");
            });

            mobileSubNavs.forEach((item, thisI) => {
                item.classList.remove("is--open");
            });

            document.querySelector('.header').classList.toggle("is--open");
        });

        subNavDesktopLinks.forEach((item, i) => {
            item.addEventListener("click", function(e) {
                e.preventDefault();

                desktopSubNavs.forEach((item, thisI) => {
                    if (i == thisI) {
                        return null;
                    }

                    item.classList.remove("is--open");
                });

                desktopSubNavs[i].classList.toggle("is--open");
            });
        });

        subNavMobileLinks.forEach((item, i) => {
            item.addEventListener("click", function(e) {
                e.preventDefault();

                mobileSubNavs.forEach((item, thisI) => {
                    if (i == thisI) {
                        return null;
                    }

                    item.classList.remove("is--open");
                });

                //$('.mobile-sub-navbars .sub-navbars').addClass('is--open');

                var newHeight = $(mobileSubNavs[i]).outerHeight();
                $('.mobile-sub-navbars .sub-navbars').height(newHeight-1);
                $('.product-hero-widget__top-section').css('padding-top', '0px');

                mobileSubNavs[i].classList.toggle("is--open");


                $('#mobileNavscreen').collapse('toggle');
            });
        });

        $('#mobileNavscreen').on('show.bs.collapse hide.bs.collapse', () => {
            this._toggleOverflowHidden();
            $('.navbar-brand').toggleClass('is--white');
        });

        $('#mobileNavscreen').on('show.bs.collapse', () => {
            this._closeAllSubNavs();
        });

        $('button.navbar-toggler').on('click', () => {
            console.log('reset all');
        });

        mobileSubNavs.forEach((item) => {
            item.querySelector('.navbar-icon-nav').addEventListener("scroll", (event) => {

                var $elem = $(event.target);
                var newScrollLeft = $elem.scrollLeft(),
                    width = $elem.outerWidth(),
                    scrollWidth = $elem.get(0).scrollWidth;
                if (scrollWidth - newScrollLeft == width) {
                    $(item).removeClass('has--gradient');
                } else {
                    $(item).addClass('has--gradient');
                }
            });
        });

    }

    _registerEvents() {
        $( window ).on('resize', () => {
            this._handleResize();
        });
    }

    _handleResize() {
        if (!this.options.viewPorts.includes(ViewportDetection.getCurrentViewport())) {
            $('#mobileNavscreen').collapse('hide');
        }
    }

    _closeAllSubNavs() {
        var subNavs = document.querySelectorAll(".sub-navbar");
        subNavs.forEach((item, thisI) => {
            item.classList.remove("is--open");
        });

        $('.mobile-sub-navbars .sub-navbars').height(0);
        $('.product-hero-widget__top-section').css('padding-top', '');
    }

    _toggleOverflowHidden() {
        $('.header, body').toggleClass('overflow-hidden');
    }

    _getSlidesPerView() {

        var windowWidth = $(window).width();
        var minWidth = 140;
        var numSlides = Math.floor(windowWidth/minWidth);

        return numSlides;
    }
}
